import { GetRecordedVideos } from '@/connection/content/videos';
import { ContentReducerCreator } from '../types';

const loadRecordingssReducer = (create: ContentReducerCreator) => {
  return create.asyncThunk(
    async (channel: number) => {
      return await GetRecordedVideos(channel);
    },
    {
      pending: (state) => {
        state.loadingContent = true;
      },
      fulfilled: (state, action) => {
        state.recordings = action.payload;
      },
      settled: (state) => {
        state.loadingContent = false;
      },
    }
  );
};

export default loadRecordingssReducer;
